import axios from "axios";
import { BASE_URL } from '../../Utils/base_url';

const AjouteMenu = async (data) => {
    return await axios.post(`${BASE_URL}/api/restaurant/ajouteMenu`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
        }
    });
}
const AfficheMenu = async (idRestaurant) => {
    return await axios.get(`${BASE_URL}/api/restaurant/afficheMenu/${idRestaurant}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
        }
    });
}

const AfficheMenuRestaurant = async (idRestaurant) => {
    return await axios.get(`${BASE_URL}/api/restaurant/afficheMenuRestaurant/${idRestaurant}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
        }
    });
}

export { AjouteMenu, AfficheMenu, AfficheMenuRestaurant }